import { makeStyles } from '@material-ui/core';
import { COLORS } from '../../utils';

export const useStyles = makeStyles({
	loadData: {
		fontSize: 12,
		color: COLORS.gray,
	},
});
